/**
 * Custom Mega Header interactions
 * Vanilla JS only
 */

function initCustomMegaHeader() {
  const header = document.querySelector('.custom-mega-header');
  if (!header) return;

  // 1. Sticky Header Logic
  const isSticky = header.classList.contains('sticky-header');
  if (isSticky) {
    let lastScroll = 0;
    const headerHeight = header.offsetHeight;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      
      // Add sticky class when scrolled past the header height
      if (currentScroll > headerHeight) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
      
      lastScroll = currentScroll;
    });
  }

  // 2. Mega Menu Hover and Focus Logic
  const navItems = document.querySelectorAll('.nav-item.has-mega-menu');
  
  navItems.forEach(item => {
    const link = item.querySelector('.nav-link');
    const megaMenu = item.querySelector('.mega-menu-panel');
    
    if (link && megaMenu) {
      // Toggle expanded state on focus/blur for accessibility
      link.addEventListener('focus', () => {
        link.setAttribute('aria-expanded', 'true');
      });
      
      item.addEventListener('focusout', (e) => {
        // If focus moves outside this nav item, close it
        if (!item.contains(e.relatedTarget)) {
          link.setAttribute('aria-expanded', 'false');
        }
      });
      
      item.addEventListener('mouseenter', () => {
        link.setAttribute('aria-expanded', 'true');
      });
      
      item.addEventListener('mouseleave', () => {
        link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // 3. Left Rail Tab Switching
  const railButtons = document.querySelectorAll('.mega-rail-btn');
  
  railButtons.forEach(btn => {
    btn.addEventListener('mouseenter', function() {
      // Find the parent mega menu
      const parentMenu = this.closest('.mega-menu-inner');
      if (!parentMenu) return;
      
      // Deactivate all buttons in this menu
      const allBtns = parentMenu.querySelectorAll('.mega-rail-btn');
      allBtns.forEach(b => b.classList.remove('is-active'));
      
      // Activate hovered button
      this.classList.add('is-active');
      
      // Hide all content panels
      const allPanels = parentMenu.querySelectorAll('.mega-content-panel');
      allPanels.forEach(p => p.classList.remove('is-active'));
      
      // Show target panel
      const targetId = this.getAttribute('data-target');
      if (targetId) {
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      }
    });
    
    // Support keyboard navigation
    btn.addEventListener('focus', function() {
      // Trigger the same logic on focus
      this.dispatchEvent(new Event('mouseenter'));
    });
  });

  // 4. Cart Drawer Integration
  const cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    cartIcon.addEventListener('click', (e) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        e.preventDefault();
        cartDrawer.open();
      }
    });
  }

  // 5. Mobile Menu Toggle
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  if (mobileToggle) {
    mobileToggle.addEventListener('click', (e) => {
      const headerDrawer = document.querySelector('header-drawer');
      if (headerDrawer) {
        const summary = headerDrawer.querySelector('summary');
        if (summary) {
          summary.click();
        }
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomMegaHeader);
} else {
  initCustomMegaHeader();
}
